export default "__VITE_ASSET__4Z_ompPM__"